// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-indicadores-monitor{
    width: 100%;
    height: auto;
    min-height: 40%;
    /* background-color: green; */
}
.cont-web-monitor{
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: red; */

}
.fieldWFstatus:hover{
  cursor: pointer;
}
.cont-grid-monitor{
    width: 100%;
    height:auto;
    min-height: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: red; */
}
.FlexContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
    align-content: start;
    width: 100%;
    /* background-color: #2f1d58; */
    height: 100%;
    overflow: auto;
    flex-direction: row;

}

.FlexContainer .cont-globe {
    width: 30%;
    height: 40%;
    /* margin:1%; */
    display: flex;
    justify-content: center;
    align-items: center;
   margin: 10px;
}
.globe-info{
    width: 90%;
    height: 90%;
    background-color: var(--white-color);
    border: 1px solid var(--border-table-color);
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* display: flex; */

}
.globe-title-info{
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--third-color);
    font-size: var(--font-size-xSmall);
}
.globe-body-info{
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.globe-half-info{
    width: 50%;
    height: 100%;
}
.cont-grafica-monitor {
  width: 100%;
  height: auto;
  min-height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.compact-grafica-monitor {
  width: 1000px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.grafica-header-info {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 173, 181, 0.08);
  color: #00adb5;
  padding: 2.5px 12px;
  margin-bottom: 7.5px;
  border-radius: 6px;
  font-size: 1.2em;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}


.spaceTitle{
    width: 100%;
    height: 10%;
    background-color: rgba(201, 201, 201, 0.178);
    color: var(--third-color);
    font-size: var(--font-size-large);
    display: flex;
    justify-content: center;
    align-items: center;
    /* border-top: 1px solid var(--border-table-color); */
}

.animate-change {
    animation: pulse 2s ease-in-out;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      background-color: transparent;
    }
    50% {
      transform: scale(1.05);
      background-color: rgba(0, 255, 106, 0.316);
    }
    100% {
      transform: scale(1);
      background-color: transparent;
    }
  }
  .titleDashTech{
    display: flex;
    width: auto;
    height: 100%;
    align-items: center;
    font-size: var(--font-size-med);
    color: var(--third-color);
  }

  .animate-increase {
    animation: highlightIncrease 2s ease;
  }
  
  @keyframes highlightIncrease {
    0% {
      background-color: #d4f8d4; /* Verde claro */
    }
    100% {
      background-color: transparent;
    }
  }
  
  /* Disminución - color rojo */
  .animate-decrease {
    animation: highlightDecrease 4s ease;
  }
  
  @keyframes highlightDecrease {
    0% {
      background-color: #ff7171;
  box-shadow: 0 8px 10px rgb(143, 0, 0);
  border: 2px solid #f60000;
    }
    100% {
      background-color: transparent;
    }
  }



.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(0, 173, 181, 0.15);
  color: #00adb5;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  margin-left: 6px;
  position: relative;
  transition: background-color 0.2s ease;
}

.info-icon:hover {
  background-color: rgba(0, 173, 181, 0.3);
}

.info-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1e293b;
  color: #fff;
  text-align: center;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: .9em;
  width: 220px;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.15);
  transition: opacity 0.25s ease;
  z-index: 20;
  pointer-events: none;
}

.info-icon:hover .info-tooltip {
  visibility: visible;
  opacity: 1;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 34px;
  transition: background-color 0.3s ease;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
}

.slider::before {
  content: "";
  position: absolute;
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #ff4b4b;
}

.switch input:checked + .slider {
  background-color: #00b894;
}

.switch input:checked + .slider::before {
  transform: translateX(24px);
  content: "";
  color: #00b894;
}

@media (max-width: 768px) {
  .spaceTitle span:first-child {
    font-size: 0.95em;
  }

  .cont-web-monitor > div {
    width: 90%;
    max-width: 400px;
    padding: 10px !important;
  }

  .globe-title-info {
    font-size: 1.25em;
  }

  .globe-body-info {
    font-size: 1.4em !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/styles/generales.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;;AAE/B;AACA;EACE,eAAe;AACjB;AACA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;GACpB,YAAY;AACf;AACA;IACI,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,2CAA2C;IAC3C,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;;AAEvB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,4CAA4C;IAC5C,yBAAyB;IACzB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,+BAA+B;EACjC;;EAEA;IACE;MACE,mBAAmB;MACnB,6BAA6B;IAC/B;IACA;MACE,sBAAsB;MACtB,0CAA0C;IAC5C;IACA;MACE,mBAAmB;MACnB,6BAA6B;IAC/B;EACF;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE;MACE,yBAAyB,EAAE,gBAAgB;IAC7C;IACA;MACE,6BAA6B;IAC/B;EACF;;EAEA,6BAA6B;EAC7B;IACE,oCAAoC;EACtC;;EAEA;IACE;MACE,yBAAyB;EAC7B,qCAAqC;EACrC,yBAAyB;IACvB;IACA;MACE,6BAA6B;IAC/B;EACF;;;;AAIF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".cont-indicadores-monitor{\r\n    width: 100%;\r\n    height: auto;\r\n    min-height: 40%;\r\n    /* background-color: green; */\r\n}\r\n.cont-web-monitor{\r\n    width: 100%;\r\n    height: 30%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* background-color: red; */\r\n\r\n}\r\n.fieldWFstatus:hover{\r\n  cursor: pointer;\r\n}\r\n.cont-grid-monitor{\r\n    width: 100%;\r\n    height:auto;\r\n    min-height: 70%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* background-color: red; */\r\n}\r\n.FlexContainer {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: start;\r\n    align-items: center;\r\n    align-content: start;\r\n    width: 100%;\r\n    /* background-color: #2f1d58; */\r\n    height: 100%;\r\n    overflow: auto;\r\n    flex-direction: row;\r\n\r\n}\r\n\r\n.FlexContainer .cont-globe {\r\n    width: 30%;\r\n    height: 40%;\r\n    /* margin:1%; */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n   margin: 10px;\r\n}\r\n.globe-info{\r\n    width: 90%;\r\n    height: 90%;\r\n    background-color: var(--white-color);\r\n    border: 1px solid var(--border-table-color);\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    /* display: flex; */\r\n\r\n}\r\n.globe-title-info{\r\n    width: 100%;\r\n    height: 20%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--third-color);\r\n    font-size: var(--font-size-xSmall);\r\n}\r\n.globe-body-info{\r\n    width: 100%;\r\n    height: 80%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.globe-half-info{\r\n    width: 50%;\r\n    height: 100%;\r\n}\r\n.cont-grafica-monitor {\r\n  width: 100%;\r\n  height: auto;\r\n  min-height: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.compact-grafica-monitor {\r\n  width: 1000px;\r\n  height: 300px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.grafica-header-info {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  background: rgba(0, 173, 181, 0.08);\r\n  color: #00adb5;\r\n  padding: 2.5px 12px;\r\n  margin-bottom: 7.5px;\r\n  border-radius: 6px;\r\n  font-size: 1.2em;\r\n  font-weight: 500;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n\r\n.spaceTitle{\r\n    width: 100%;\r\n    height: 10%;\r\n    background-color: rgba(201, 201, 201, 0.178);\r\n    color: var(--third-color);\r\n    font-size: var(--font-size-large);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* border-top: 1px solid var(--border-table-color); */\r\n}\r\n\r\n.animate-change {\r\n    animation: pulse 2s ease-in-out;\r\n  }\r\n  \r\n  @keyframes pulse {\r\n    0% {\r\n      transform: scale(1);\r\n      background-color: transparent;\r\n    }\r\n    50% {\r\n      transform: scale(1.05);\r\n      background-color: rgba(0, 255, 106, 0.316);\r\n    }\r\n    100% {\r\n      transform: scale(1);\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  .titleDashTech{\r\n    display: flex;\r\n    width: auto;\r\n    height: 100%;\r\n    align-items: center;\r\n    font-size: var(--font-size-med);\r\n    color: var(--third-color);\r\n  }\r\n\r\n  .animate-increase {\r\n    animation: highlightIncrease 2s ease;\r\n  }\r\n  \r\n  @keyframes highlightIncrease {\r\n    0% {\r\n      background-color: #d4f8d4; /* Verde claro */\r\n    }\r\n    100% {\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  \r\n  /* Disminución - color rojo */\r\n  .animate-decrease {\r\n    animation: highlightDecrease 4s ease;\r\n  }\r\n  \r\n  @keyframes highlightDecrease {\r\n    0% {\r\n      background-color: #ff7171;\r\n  box-shadow: 0 8px 10px rgb(143, 0, 0);\r\n  border: 2px solid #f60000;\r\n    }\r\n    100% {\r\n      background-color: transparent;\r\n    }\r\n  }\r\n\r\n\r\n\r\n.info-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background-color: rgba(0, 173, 181, 0.15);\r\n  color: #00adb5;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  margin-left: 6px;\r\n  position: relative;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.info-icon:hover {\r\n  background-color: rgba(0, 173, 181, 0.3);\r\n}\r\n\r\n.info-tooltip {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  position: absolute;\r\n  bottom: 125%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background-color: #1e293b;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  font-size: .9em;\r\n  width: 220px;\r\n  box-shadow: 0px 2px 8px rgba(0,0,0,0.15);\r\n  transition: opacity 0.25s ease;\r\n  z-index: 20;\r\n  pointer-events: none;\r\n}\r\n\r\n.info-icon:hover .info-tooltip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 50px;\r\n  height: 26px;\r\n}\r\n\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #ccc;\r\n  border-radius: 34px;\r\n  transition: background-color 0.3s ease;\r\n  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.slider::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 22px;\r\n  width: 22px;\r\n  left: 2px;\r\n  bottom: 2px;\r\n  background-color: white;\r\n  border-radius: 50%;\r\n  transition: transform 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  color: #ff4b4b;\r\n}\r\n\r\n.switch input:checked + .slider {\r\n  background-color: #00b894;\r\n}\r\n\r\n.switch input:checked + .slider::before {\r\n  transform: translateX(24px);\r\n  content: \"\";\r\n  color: #00b894;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .spaceTitle span:first-child {\r\n    font-size: 0.95em;\r\n  }\r\n\r\n  .cont-web-monitor > div {\r\n    width: 90%;\r\n    max-width: 400px;\r\n    padding: 10px !important;\r\n  }\r\n\r\n  .globe-title-info {\r\n    font-size: 1.25em;\r\n  }\r\n\r\n  .globe-body-info {\r\n    font-size: 1.4em !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
